import { motion } from "framer-motion";
import { PageShell } from "@/components/PageShell";
import { usePageMeta } from "@/hooks/usePageMeta";

const TEAM = [
  { initials: "JR", name: "Jordan Reyes", role: "Managing Partner", note: "Ex-agency CEO. Fifteen years scaling California brands from first dollar to eight figures." },
  { initials: "AM", name: "Ava Moreno", role: "Partner, Brand & Design", note: "Award-winning art director behind identity systems for hospitality, finance, and tech." },
  { initials: "DK", name: "David Kim", role: "Partner, Paid Media", note: "Managed $40M+ across Google, Meta, and Yelp. Obsessed with one number: your return." },
  { initials: "SP", name: "Sofia Patel", role: "Partner, Engineering", note: "Builds the sites and systems that turn attention into revenue. Speed is her love language." },
];

export default function Team() {
  usePageMeta(
    "The Partners — Senior People, No Hand-offs | Build Right Partners",
    "Meet the partners behind Build Right Partners — senior brand, paid media, and engineering leads serving businesses across California."
  );
  return (
    <PageShell testid="team-page" overline="The Partners" title="Senior people." italic="No hand-offs.">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-28">
        <p className="max-w-xl text-base font-light leading-relaxed text-slate-300 mb-14">
          When you hire Build Right, these are the people in the room. No account managers relaying
          messages to a junior pod — partners do the work and answer the phone.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-amber-500/10 border border-amber-500/10">
          {TEAM.map((m, i) => (
            <motion.div
              key={m.name}
              data-testid={`team-member-${i + 1}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group bg-[#0A1128] p-9 hover:bg-[#0F1A3A] transition-colors duration-500"
            >
              <div className="h-20 w-20 rounded-full border border-amber-400/40 flex items-center justify-center font-serif text-2xl text-amber-300 group-hover:bg-amber-400 group-hover:text-[#060B18] transition-colors duration-500">
                {m.initials}
              </div>
              <h2 className="mt-7 font-serif text-2xl font-semibold text-amber-50">{m.name}</h2>
              <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-amber-400/80">{m.role}</p>
              <p className="mt-4 text-sm font-light leading-relaxed text-slate-300/85">{m.note}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
